<i18n>
{
	"en": {
		"title": "Deviation Status"
	},
	"no": {
		"title": "Avviksstatus"
	}
}
</i18n>

<template>
	<t-combobox
		:title="$t('title')"
		:showCount="false"
		showPopoverOnFocus

		:searchValue="searchValue"
		:items="deviationStatuses"
		:selected="value"

		:disabled="disabled || hasNoDeviationStatuses"

		:filterFunction="filterFunction"
		:sortFunction="sortFunction"

		@input="onInput"
		@change="onChange"
		@blur="onBlur"
	>
		<template #optionItemContent="slotProps">
			<div class="item">
				<div class="item-main-text">{{getItemDisplayText(slotProps.item)}}</div>
			</div>
		</template>
	</t-combobox>
</template>

<script>
import { mapActions } from '../store/newDeviation.store';
import { isValidNumber } from '@/core';

export default {
	name: 'DeviationStatusInput',
	props: {
		value: Object,
		disabled: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			deviationStatuses: [],
			searchValue: '',
		};
	},

	computed: {
		hasNoDeviationStatuses() {
			return !this.deviationStatuses || this.deviationStatuses.length === 0;
		},
	},

	watch: {
		value: {
			immediate: true,
			handler(deviationStatus) {
				if (!deviationStatus || Object.keys(deviationStatus).length === 0) {
					this.searchValue = '';
				} else if (isValidNumber(deviationStatus.id)) {
					this.searchValue = this.getItemDisplayText(deviationStatus);
				}
			}
		}
	},

	async created() {
		this.deviationStatuses = await this.getDeviationStatuses();
	},

	methods: {
		...mapActions(['getDeviationStatuses']),
		onInput(searchValue) {
			this.searchValue = searchValue;
		},

		onChange(event) {
			if (event && isValidNumber(event.id)) {
				this.searchValue = this.getItemDisplayText(event);
				this.$emit('change', event);
			} else
				this.$emit('change', undefined);
		},

		onBlur() {
			if (this.searchValue === '') {
				this.$emit('change', undefined);
				return;
			}
			let deviationStatus = this.deviationStatuses.find(
				deviationStatus => this.searchValue.toLowerCase() === deviationStatus[this.$i18n.locale].toLowerCase()
			);
			if (deviationStatus && deviationStatus !== this.value) {
				this.$emit('change', deviationStatus);
			} else
				this.searchValue = this.getItemDisplayText(this.value);
		},

		getItemDisplayText(item) {
			if (!item) return '';
			let id = isValidNumber(item.id) && `${item.id}` || '';
			let name = item[this.$i18n.locale] || item.en || '';
			if (id && name) return `${id} - ${name}`;
			else return id || name;
		},

		filterFunction(deviationStatus) {
			return	`${deviationStatus.id}`.includes(this.searchValue)
				|| deviationStatus[this.$i18n.locale].toLowerCase().includes(this.searchValue.toLowerCase());
		},
		sortFunction: (a, b) => {
			if (a.id < b.id) return -1;
			if (a.id > b.id) return 1;
			return 0;
		},
	}
};
</script>
